// src/components/ExamGuardOverlay.jsx
import React from 'react';

export default function ExamGuardOverlay({ visible, onReenter }) {
    if (!visible) return null;
    return (
        <div
            role="dialog"
            aria-modal="true"
            style={{
                position:'fixed', inset:0, background:'rgba(0,0,0,0.75)',
                display:'flex', alignItems:'center', justifyContent:'center',
                zIndex: 9999, color:'#fff', padding: 24
            }}
        >
            <div style={{ maxWidth: 560, textAlign:'center' }}>
                <h2 style={{ marginTop:0 }}>Wróć do trybu pełnoekranowego</h2>
                <p style={{ opacity:0.9 }}>
                    Aby kontynuować egzamin, włącz pełny ekran. Wyjścia z pełnego ekranu są rejestrowane.
                </p>
                <button
                    onClick={onReenter}
                    style={{
                        marginTop:12, padding:'10px 16px', borderRadius:10, border:'none',
                        background:'#22c55e', color:'#001b0a', fontWeight:700, cursor:'pointer'
                    }}
                >
                    Włącz pełny ekran i kontynuuj
                </button>
            </div>
        </div>
    );
}
